<template>
  <section class="contact-us h-[550px] lg:h-[372px]">
    <ContactUsBanner />
    <div class="container z-10 absolute right-0 left-0 mr-auto ml-auto">
      <ContactUsInfo class="mt-[-115px] lg:mt-[-50px]" />
    </div>
  </section>
</template>
<script>
import { mapGetters } from 'vuex'
import { renderHead } from '@helper/head/head-home'
import ContactUsBanner from '@/components/pages/contact-us/contact-us-banner'
import ContactUsInfo from '@/components/pages/contact-us/contact-us-info'

export default {
  name: 'ContactUsPage',
  components: { ContactUsInfo, ContactUsBanner },
  auth: false,
  layout: 'main',
  async asyncData ({ store }) {
    await store.dispatch('local/asyncDataContactUs')
  },
  head () {
    return renderHead({ meta: this.getMeta })
  },
  computed: {
    ...mapGetters('global', ['getMeta'])
  }
}
</script>

<style scoped lang="scss">
.contact-us {
  @apply mb-20 lg:mb-[160px];
}
</style>
